import type {TreeStructure} from '@pb/kit-component-tree-v2';
import type {UserList} from 'src/openapi/admin/models/UserList';

export const parseUsers = ({users}: UserList): TreeStructure => {
    return users.map(({userId, fullUserName}) => ({id: `${userId}`, caption: fullUserName}));
};
